function hasInvoicePrivs(context) {
  return context.roleCheck('pr_device', 'Manage');
}

export default {
  priv: 'pr_device',
  overviewTitle: 'Meetrapporten',
  detailTitle: 'Meetrapport',
  deleteTitle: 'dit rapport',
  url: '/devices/measurereports',
  apiUrl: '/devicereports/',
  multiSelect(context) {
    return hasInvoicePrivs(context);
  },
  sortBy: ['report_code'],
  sortDesc: [true],
  deletable: true,
  editable: true,
  forEdit: true,
  newRecord: {
    signature_required: true,
    check_software: false,
    external_report: 0,
    conclusion: false,
    device: {
      user_address_id: 0,
      admin_address_id: 0,
      import_address_id: 0,
      owner_address_id: 0
    },
    trafficlight: false
  },
  filterName: 'devicereports',
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'string'
  },
  advancedSearchFields(context) {
    const commonFields = [
      {
        text: 'Zoek tekst',
        value: 'misc_search',
        type: 'text'
      },
      {
        text: 'Beheerder',
        value: 'admin_address_id',
        type: 'optionList',
        optionListName: 'addresses',
        optionListParams: { priv_manager: 'yes' }
      },
      {
        text: 'Toezichter',
        value: 'supervisor_id',
        type: 'optionList',
        optionListName: 'supervisors'
      },
      {
        text: 'Type',
        value: 'devicetest_id',
        type: 'optionList',
        optionListName: 'devicetests'
      },
      {
        text: 'Gebruiker',
        value: 'user_address_id',
        type: 'optionList',
        optionListName: 'addresses',
        optionListParams: { priv_user: 'yes' }
      },
      {
        text: 'Eigenaar',
        value: 'owner_address_id',
        type: 'optionList',
        optionListName: 'addresses',
        optionListParams: { priv_owner: 'yes' }
      },
      {
        text: 'Periode van',
        value: 'date_start',
        type: 'date'
      },
      {
        text: 'Periode tot',
        value: 'date_end',
        type: 'date'
      },
      {
        text: 'Interventiepersoon',
        value: 'interventionperson_id',
        type: 'optionList',
        optionListName: 'interventionpersons'
      },
      {
        text: 'Verantwoordelijke',
        value: 'responsiblecontact_id',
        type: 'optionList',
        optionListName: 'responsiblecontacts'
      },
      {
        text: 'Meest recente rapporten',
        value: 'most_recent',
        type: 'boolean'
      }
    ];
    // Add invoiced filter if the user has manage privileges on this view
    if (hasInvoicePrivs(context)) {
      const invoicedFilter = {
        text: 'Gefactureerd',
        value: 'is_invoiced',
        type: 'optionList',
        optionList: [
          {
            value: false,
            text: 'Nee'
          },
          {
            value: true,
            text: 'Ja'
          }
        ]
      };
      commonFields.push(invoicedFilter);
    }
    return commonFields;
  },
  tableFields(context) {
    const commonFields = [
      {
        text: 'Naam',
        value: 'report_code',
        link: '/devices/measurereports/{id}',
        width: '10%'
      },
      {
        text: 'Datum',
        value: 'date',
        width: '10%',
        filter: 'date'
      },
      {
        text: 'Omschrijving',
        value: 'desc',
        width: '20%'
      },
      {
        text: 'Serienummer',
        value: 'serial_nr',
        width: '10%'
      },
      {
        text: 'Gebruiker',
        value: 'user_name',
        width: '20%'
      },
      {
        text: 'Rapport NL',
        value: 'report_file_id_nl_ov',
        type: 'file',
        width: '4%',
        align: 'center',
        sortable: false
      },
      {
        text: 'Rapport FR',
        value: 'report_file_id_fr_ov',
        type: 'file',
        width: '4%',
        align: 'center',
        sortable: false
      },
      {
        text: 'Certificaat NL',
        value: 'certificate_file_id_nl_ov',
        type: 'file',
        width: '4%',
        align: 'center',
        sortable: false
      },
      {
        text: 'Certificaat FR',
        value: 'certificate_file_id_fr_ov',
        type: 'file',
        width: '4%',
        align: 'center',
        sortable: false
      }
    ];
    // Add invoiced filter if the user has manage privileges on this view
    if (hasInvoicePrivs(context)) {
      const invoicedColumn = {
        text: 'Gefactureerd',
        value: 'is_invoiced',
        type: 'boolean',
        width: '4%',
        align: 'center',
        sortable: false
      };
      commonFields.push(invoicedColumn);
    }
    return commonFields;
  },
  customEditable(item) {
    return !item.conclusion || item.isAdmin;
  }
};
